
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CheckoutManager } from '@core-managers/checkout.manager';
import { TokenManager } from '@core-managers/token.manager';
import { UserTokenStorage } from '@shared-base/generic-clases.base';
import { Observable, of } from 'rxjs';
import { RedeemManager } from '@core-managers/redeem.manager';
import { EStatusHEM } from '@core-constants/made-in-mexico.const';
import { UserAccessDataService } from '@core-data-services/security/user-access.data-service';

@Injectable({ providedIn: 'root' })
export class InitiativesDataGuard 
{
  constructor(private router: Router,
    public checkoutManager: CheckoutManager,
    protected redeemManager: RedeemManager,
    public userAccessDataService: UserAccessDataService,
    public tokenManager: TokenManager) { }

  public canActivate(): Observable<boolean>
  {
    const user: UserTokenStorage = this.tokenManager.getUser();
    
    if (!user)
    {
      return this.returnToInitiatives();
    }

    const status = this.redeemManager.status;
    if (status !== EStatusHEM.InProcess)
    {
      return this.returnToInitiatives();
    }

    return this.userAccessDataService.$validateSession();
  }

  public returnToInitiatives(): Observable<boolean>
  {
    this.router.navigate(["/iniciativas"]);
    return of(false);
  }

}
